import { StyleSheet } from 'react-native';
import { neutrals } from 'src/theme/colors';

export const styleShared = StyleSheet.create({
  textWrapper: {
    alignItems: 'center',
    gap: 11,
  },
  details: {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: 24,
  },
  text: {
    color: neutrals.neutralGrays.tarmac,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 22,
    textAlign: 'center',
  },
  buttonText: {
    color: neutrals.white,
    fontSize: 18,
    fontWeight: 700,
    lineHeight: 27,
    textAlign: 'center',
  },
  description: {
    fontWeight: 400,
    fontSize: 18,
    lineHeight: 27,
    color: neutrals.neutralGrays.graphite,
  },
});

export const stylesMobile = StyleSheet.create({
  ...styleShared,
  button: {
    width: 280,
  },
  title: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 26,
    color: neutrals.neutralGrays.graphite,
    textAlign: 'center',
  },
});

export const stylesDesktop = StyleSheet.create({
  ...styleShared,
  button: {
    width: 280,
  },
  title: {
    fontWeight: 700,
    fontSize: 24,
    lineHeight: 31,
    color: neutrals.neutralGrays.graphite,
    textAlign: 'center',
  },
});
